import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";

const header = [
  {
    label: 'Profile',
    field: 'profile',
    sort: 'asc',
    width: 40,
    type:"IMAGE",
    editType:"file"
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 150,
    editType:"text"
  },
  {
    label: 'Department',
    field: 'department',
    sort: 'asc',
    width: 270,
    editType:"LINKEDLIST",
    options:[]
  },
  {
    label: 'Phone',
    field: 'phone',
    sort: 'asc',
    width: 200,
    editType:"phone",
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc',
    width: 100,
    editType:"email",
  },
  {
    label: 'Password',
    field: 'password',
    sort: 'asc',
    width: 150,
    editType:"password",
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc',
    width: 100,
    editType:"SELECT",
    options:[{name:"Active",value:"ACTIVE"},{name:"Not Active",value:"NOTACTIVE"},]
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'asc',
    width: 110,
    type:'ACTIONS'
  }
];

const baseName = "User";
const firebaseDb = firebases.database().ref().child('user');
const firebaseDbDepartment = firebases.database().ref().child('departments');
let context = null;

const UserAdd = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="User Profile" subtitle="Add New User" sm="4" className="text-sm-left" />
    </Row>
    <Row>
    
      <Col lg="10">
        <FormItem title="User Details"  firebaseLinkedList={firebaseDbDepartment} model={header} action="Add New User" firebaseDb={firebaseDb} firebaseStorage={files}/>
      </Col>
    </Row>
  </Container>
);

export default UserAdd;
